import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'TelegramAPI';

export const telegramAPI = {
  get: async (projectUUID, lastID, showNotification = true) => {
    try {
      const params = { project_uuid: projectUUID, last_id: lastID };
      const response = await api.get(`/${projectUUID}/tg-get`, { params });
      return handleSuccessResponse(response, MODULE_NAME, 'Получение сообщений телеграмма', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получение сообщений телеграмма');
    }
  },
};